export default __webpack_public_path__ + "static/media/bg2.3d6a0eb0.png";